// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationWebpageProcessDateApi,
  ICertificationWebpageProcessDateApiRequest,
  ICertificationWebpageProcessDateApiResponse,
  ICertificationWebpageProcessDateApiGetDetailAttrs,
  ICertificationWebpageProcessDateApiUpdateAttrs,
} from 'interfaces/webpage/certification/registration/process-date/process-date-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class CertificationWebpageProcessDateApi
  extends BaseApi<ICertificationWebpageProcessDateApi>
  implements ICertificationWebpageProcessDateApiRequest
{
  readonly url = ApiConstantHc.CERTIFICATION_REGISTRATION_PROCESS_DATE_URL
  private certificateRegistrationProcessDateUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get process date list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpageProcessDateApiGetDetailAttrs}
   *
   * @return {Promise<ICertificationWebpageProcessDateApiResponse>} Promise<ICertificationWebpageProcessDateApiResponse>
   */
  async certificationWebpageProcessDate_getDetail(
    payload: ICertificationWebpageProcessDateApiGetDetailAttrs,
  ): Promise<ICertificationWebpageProcessDateApiResponse> {
    return this.POST(
      `${this.certificateRegistrationProcessDateUrl}/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Update process date
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpageProcessDateApiUpdateAttrs}
   *
   * @return {Promise<ICertificationWebpageGeneralProofApiNullResponse>} Promise<ICertificationWebpageGeneralProofApiNullResponse>
   */
  async certificationWebpageProcessDate_update(
    payload: ICertificationWebpageProcessDateApiUpdateAttrs,
  ): Promise<ICertificationWebpageProcessDateApiResponse> {
    return this.POST(`${this.certificateRegistrationProcessDateUrl}/update/${payload.params.assessmentId}`, payload.body, {
      ...payload.requestConfig,
    })
  }
}
